// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {Fragment, useContext, useEffect, useMemo, useRef,
    useState} from 'react';
import cn from 'classnames';
import '../css/core/input.less';
import '../css/core/select.less';
import Icon_x from '../img/svg/icon/ic-x.svg';
import Icon_check from '../img/hola2023/icons/16/check.svg';
import Icon_chevron_down from '../img/svg/icon/chevron_down.svg';
import Icon_search2 from '../img/svg/icon/search-2.svg';
import {Svg} from '../ui/svg';
import {Settings_context} from '../settings_ctx';
import {Input} from './input';
import {use_browser} from './use_browser';
import Generic_flag from '../img/hola2023/generic.svg';

export interface i_select_item {
    value: string;
    title?: string | JSX.Element;
    full_title?: string;
    tags?: string;
    rendered_item?: JSX.Element;
    disabled?: boolean;
}
export interface i_custom_body_props<T = string> {
    value: T;
    on_select: (value:T, close?: boolean)=>void;
    on_cancel: ()=>void;
}
interface i_select_props<T = string> {
    on_select: (name: string, value: T, ev:any)=>void;
    on_filter_changed?: (name: string, filter: string)=>void;
    name?: string;
    class_name?: string;
    title?: string;
    items: i_select_item[]| object_of<string>;
    value: T;
    on_open?: any;
    on_close?: any;
    auto_width?: boolean;
    expand?: 'left';
    selected?: string | JSX.Element;
    is_error?: any;
    label?: string;
    top?: boolean;
    borderless?: boolean;
    size?: string;
    html?: boolean;
    no_overflow?: boolean;
    Custom_body?: (props:i_custom_body_props<T>)=>JSX.Element;
    on_focus?: ()=>void;
    on_enter_pressed?: (cursor: number, name: string, v: T)=>boolean;
    icon?: JSX.Element;
    tag_style?: boolean;
    select_best_on_blur?: boolean;
    allow_search_in_body?: boolean;
    color?: 'primary'|'default';
    mobile_full_screen?: boolean;
    border_class_name?: string;
    width?: boolean;
    no_check?: boolean;
    hide_active?: boolean;
    field_cls?: string;
    li_cls?: string;
    li_cls_active?: string;
    opened_cls?: string;
    disabled?: boolean;
    no_focus?: boolean;
    btn_with_flag?: boolean;
    svg_cls?: string;
}
const select_d_state = {opened: false, filter: null, cursor: -1, best: null};
const select_d_state_inv = {opened: false, cursor: -1, best: null};
type Select_cmp = <T>(props:i_select_props<T>)=>JSX.Element;
const if_el_in_root = (el, root)=>{
    while (el)
    {
        if (el==root)
            return true;
        el = el.parentElement;
    }
    return false;
};

export const Select:Select_cmp = ({on_select, name, class_name, title, items,
    value, top, on_open, auto_width, expand, selected, is_error, label,
    borderless, size, Custom_body, html, on_filter_changed, on_focus,
    icon, on_enter_pressed, no_overflow, tag_style, on_close,
    select_best_on_blur, allow_search_in_body, color, mobile_full_screen,
    border_class_name, width, no_check, hide_active, field_cls, svg_cls,
    li_cls, li_cls_active, opened_cls, disabled, no_focus, btn_with_flag})=>{
    const is_items_array = Array.isArray(items);
    const [{opened, filter, cursor, best}, set_state] = useState(
        select_d_state);
    const {theme, theme_name, popups} = useContext(Settings_context);
    const is_hola2023 = theme_name != 'default' && theme_name != 'purple';
    const is_toolip = theme_name == 'toolip'; // XXX dmitriiz: this is insane!
    const ul_ref = useRef(null);
    const border_ref = useRef(null);
    const input_ref = useRef(null);
    const border_less_btn_ref = useRef(null);
    const timers = useMemo(()=>({on_blur: 0 as any}), []);
    const [add_close_hdl, set_add_close_hdl] = useState(false);
    const browser = use_browser();
    useEffect(()=>{
        const hide = ()=>set_state(st=>({...st, ...select_d_state_inv}));
        window.addEventListener('click', hide);
        return ()=>window.removeEventListener('click', hide);
    }, []);
    useEffect(()=>{
        if (!borderless)
            return;
        setTimeout(()=>{
            set_add_close_hdl(opened);
        }, 200);
    }, [opened]);
    useEffect(()=>{
        if (best)
            on_select(name, best, null);
    }, [best]);
    useEffect(()=>{
        const calc_max_width = ()=>{
            if (ul_ref.current)
            {
                const li_el = ul_ref.current.querySelectorAll('li');
                let max_width = 0;
                li_el.forEach(li=>{
                    const li_width = li.textContent.length;
                    max_width = li_width > max_width ? li_width : max_width;
                });
                const main_div = ul_ref.current.parentElement.parentElement;
                if (width)
                    main_div.style.width = `${max_width}ch`;
            }
        };
        calc_max_width();
    }, []);
    const on_focus_hdl = ev=>{
        if (disabled)
            return;
        if (!opened)
        {
            if (browser=='safari' && ev?.target)
                ev.target.focus();
            if (timers.on_blur)
                clearTimeout(timers.on_blur);
            on_open && on_open();
            set_state(st=>({...st, opened: true}));
            if (!borderless && !is_hola2023)
            {
                ev.target.setSelectionRange(0, ev.target.value
                    && ev.target.value.length || 255);
            }
            if (on_focus)
                on_focus();
        }
    };
    const close = ()=>{
        if (on_close)
            on_close();
        set_state(st=>({...st, ...select_d_state_inv}));
    };
    const on_blur = ()=>{
        if (opened)
        {
            // XXX dmitriiz: double settimeout for safari
            timers.on_blur = setTimeout(()=>{
                // @ts-ignore
                const active_el = window.safari_clicked
                    || document.activeElement;
                if (border_ref &&
                    if_el_in_root(active_el, border_ref.current))
                {
                    const blur_active_fn = ()=>{
                        on_blur();
                        active_el.removeEventListener('blur', blur_active_fn);
                    };
                    active_el.addEventListener('blur', blur_active_fn);
                    return;
                }
                set_state(st=>{
                    if (select_best_on_blur && st.filter)
                    {
                        const first_item = filtered.length ? filtered[0]
                            : keys[0];
                        if (first_item)
                        {
                            const best_v = is_items_array ? first_item.value
                                : first_item;
                            return {...st, ...select_d_state, best: best_v};
                        }
                    }
                    return {...st, ...select_d_state_inv};
                });
            }, browser=='safari' ? 500 : 100);
        }
    };
    const stop_click = ev=>ev.stopPropagation();
    const on_click = (n, v, ev)=>{
        if (ev.button!=0)
            return;
        ev.stopPropagation();
        const active_el = ev.target;
        if (Custom_body && border_ref &&
            if_el_in_root(active_el, border_ref.current))
        {
            return;
        }
        if (input_ref && input_ref.current)
            input_ref.current.focus();
        on_select(n, v, ev);
        setTimeout(()=>set_state(st=>({...st, ...select_d_state})), 0);
    };
    const on_mouse_move = ()=>{
        if (cursor!=-1)
            set_state(st=>({...st, cursor: -1}));
    };
    // ignore because of "items" type. Could be object or array
    // @ts-ignore
    const keys:any[] = is_items_array ? items : Object.keys(items);
    let filtered = [];
    if (filter && !on_filter_changed)
    {
        const f_up = filter.toUpperCase();
        filtered = is_items_array ?
            keys.filter((k:i_select_item)=>{
                const value_ = k.value || '';
                if (value_.indexOf('separator')>-1)
                    return false;
                const title_ = k.title || '';
                const full_title_ = k.full_title || '';
                const tags_ = k.tags || '';
                let title_includes = false;
                if (typeof title_ == 'string')
                    title_includes = title_.toUpperCase().includes(f_up);
                return title_includes ||
                    value_.toUpperCase().includes(f_up) ||
                    full_title_.toUpperCase().includes(f_up) ||
                    tags_.toUpperCase().includes(f_up);
            }) :
            keys.filter(k=>items[k].toUpperCase().startsWith(f_up));
    }
    const handle_key_down = ev=>{
        if (disabled)
            return;
        if (ev.keyCode==13 && opened) // enter
        {
            const index = cursor > -1 ? cursor : 0;
            const v_select = filtered.length ? filtered[index] : keys[index];
            const should_on_select = !on_enter_pressed ||
                on_enter_pressed(cursor, name, !v_select ? undefined :
                    is_items_array ? v_select.value : v_select);
            if (v_select && should_on_select)
            {
                on_select(name, is_items_array ? v_select.value
                    : v_select, ev);
                set_state(st=>({...st, ...select_d_state}));
            }
            ev.stopPropagation();
        }
        if (ev.keyCode==40)
        {
            let next = cursor + 1;
            if (is_items_array)
            {
                while (true)
                {
                    if (next >= keys.length)
                        next = 0;
                    if (next == cursor)
                        break;
                    if (keys[next] && keys[next].disabled)
                        next++;
                    else
                        break;
                    if (next == cursor)
                        break;
                }
            }
            set_state(st=>({...st, cursor: next, opened: true}));
            if (ul_ref && ul_ref.current)
            {
                ev.preventDefault();
                const li_h = ul_ref.current.children[0] &&
                    ul_ref.current.children[0].offsetHeight || 28;
                ul_ref.current.scrollTop = next * li_h;
            }
        }
        if (ev.keyCode==38 && opened && cursor > -1)
        {
            let next = cursor - 1;
            if (is_items_array)
            {
                while (true)
                {
                    if (next < 0)
                        next = keys.length - 1;
                    if (next == cursor)
                        break;
                    if (keys[next] && keys[next].disabled)
                        next--;
                    else
                        break;
                    if (next == cursor)
                        break;
                }
            }
            set_state(st=>({...st, cursor: next}));
            if (ul_ref && ul_ref.current)
            {
                ev.preventDefault();
                const li_h = ul_ref.current.children[0] &&
                    ul_ref.current.children[0].offsetHeight || 28;
                ul_ref.current.scrollTop = next * li_h;
            }
        }
        if (ev.keyCode==27) // esc
            set_state(st=>({...st, ...select_d_state}));
        if (ev.keyCode==9) // tab
            set_state(st=>({...st, ...select_d_state_inv}));
    };
    const set_filter_value = filter_v=>{
        if (on_filter_changed)
            on_filter_changed(name, filter_v);
        set_state(st=>({...st, cursor: -1, filter: filter_v, opened: true}));
        if (filter_v=='' && !allow_search_in_body)
            on_select(name, '' as any, undefined);
    };
    const on_filter_change = ev=>{
        if (disabled)
            return;
        const filter_v = ev.target.value;
        set_filter_value(filter_v);
    };
    const cls = cn('hola_select', class_name, keys.length && opened
        && cn('hola_select--opened', opened_cls),
        value && 'hola_select--choosed',
        color && `hola_select--color-${color}`,
        label ? 'with_lbl' : '',
        icon ? 'hola_select--custom_chevron' : '',
        borderless && 'hola_select--borderless',
        is_error && 'hola_input--with_error',
        no_overflow && 'hola_select--no_overflow',
        Custom_body && 'hola_select--custom_body',
        size && `hola_select--${size}`,
        is_hola2023 && 'hola_select--hola2023_theme',
        disabled && 'hola_select--disabled');
    const input_cls = cn('hola_input hola_select_title',
        is_error && 'hola_input--error',
        size && `hola_input--${size}`,
        !!field_cls && field_cls);
    let value_obj;
    if (value!==undefined)
    {
        // @ts-ignore
        value_obj = is_items_array ? items.find(i=>i.value==value)
        // @ts-ignore
            : items[value];
    }
    const border_cls = cn('hola_select_border',
        top && 'hola_select_border--top',
        size && `hola_select--${size}`,
        auto_width && 'hola_select_border--auto_width',
        expand=='left' && 'hola_select_border--left',
        mobile_full_screen && 'hola_select_border--mobile_full_screen',
        !!border_class_name && border_class_name);
    const calc_value = selected ? selected :
        filter!==null && !allow_search_in_body ? filter :
        value_obj && (is_items_array ? value_obj.title : value_obj) || '';
    const need_tag = value_obj && tag_style;
    const default_icon = <Icon_chevron_down width={24} height={24}/>;
    return <div className={cls} onKeyDown={handle_key_down}
      onClick={event=>{
        stop_click(event);
        popups.forEach(c=>c());
      }} onMouseDown={stop_click}>
      <Svg icon={icon||default_icon}
        on_click={()=>{
          if (input_ref && input_ref.current)
            input_ref.current.focus();
          else if (border_less_btn_ref && border_less_btn_ref.current)
            border_less_btn_ref.current.focus();
        }}
        cls={cn('hola_select_chevron', svg_cls)}/>
      {label && <span className={cn('lbl', !is_hola2023 && theme.xs,
        is_toolip ? cn(theme.P, theme.p4, theme.reg) :
          is_hola2023 && cn(theme.P, theme.p5, theme.med))}>
        {label}</span>}
      {borderless ?
        <button className={is_hola2023 ? input_cls : 'hola_select_bl_title'}
          onFocus={on_focus_hdl} onBlur={on_blur} onClick={ev=>{
            if (add_close_hdl)
              close();
            else
              on_focus_hdl(ev);
          }} ref={border_less_btn_ref}>
          {btn_with_flag ? <Generic_flag/> : null}
          {calc_value||title}</button> :
        <Fragment>
          <input type="text" className={input_cls} onBlur={on_blur}
            ref={input_ref} placeholder={title || ' '}
            value={need_tag ? ' ' : calc_value}
            onClick={on_focus_hdl} onChange={on_filter_change}
            onFocus={on_focus_hdl} readOnly={no_focus || !!selected}/>
          {need_tag && <div className='hola_select_tag'>
            <span className={cn(theme.p3, theme.reg)}>{calc_value}</span>
            </div>}
        </Fragment>}
      <div ref={border_ref} className={border_cls} onClick={e=>{
        e.stopPropagation();
      }}>
        {Custom_body ? <Custom_body value={value}
          on_select={(value_data, need_close)=>{
            on_select(name, value_data, undefined);
            if (need_close)
              close();
          }} on_cancel={()=>close()}/> : <Fragment>
          {allow_search_in_body &&
            <Input on_change={v=>on_filter_change({target: {value: v}})}
              icon={filter ? <Icon_x width={16} height={16}/> :
                <Icon_search2 width={16} height={16}/>}
              placeholder={'Search'} size={'sm'} cl={'filter_input'}
              value={filter} on_icon_click={filter ? ev=>{
                on_filter_change({target: {value: ''}});
                ev.currentTarget.parentElement.querySelector('input').focus();
                ev.stopPropagation();
              } : undefined}/>}
          <ul onMouseMove={on_mouse_move} ref={ul_ref}
            className={cn('hola_select_border_list',
            allow_search_in_body && 'hola_select_border_list--top_offset')}>
            {(filtered.length && filtered || keys).map((k, i)=>{
              const i_value = is_items_array ? k.value : k;
              if (i_value==value && hide_active)
                  return;
              const is_disabled = is_items_array ? k.disabled : false;
              const cls_li = cn(li_cls,
                    i_value==value && cn('active', li_cls_active),
                  i==cursor && 'hovered', is_disabled && 'disabled');
              if (html)
              {
                return <li key={i} className={cls_li}
                  onMouseDown={is_disabled ? undefined :
                    ev=>on_click(name, i_value, ev)}
                  dangerouslySetInnerHTML={{__html: is_items_array ?
                    k.rendered_item || k.full_title || k.title
                    : items[k]}}/>;
              }
              return <li key={i} className={cls_li}
                onMouseDown={is_disabled ? undefined :
                  ev=>on_click(name, i_value, ev)}>
                {is_items_array ? k.rendered_item || k.full_title || k.title
                  : items[k]}
                {is_hola2023 && i_value==value && !no_check && <Svg
                  icon={<Icon_check width={16} height={16}/>}
                  cls="check_icon"/>}
              </li>;
          })}
          </ul>
        </Fragment>}
      </div>
    </div>;
};
